import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getApplications } from '../../redux/actions/ApplicationsActions';

import NavigationComponent from '../commonComponents/util/NavigationComponent';
import ACHResultsTable from './ACHResultsTable';
import '../../styles/components/ach-results.css';

class ACHResultsPage extends NavigationComponent {
    constructor(props) {
        super(props);
    }



    render() {
        const { achResults } = this.props;
        
        const successfulTransfers = achResults.filter(transfer => transfer.success);
        const transfersFailed = achResults.filter(transfer => !transfer.success);
        
        return (
            <div className="secondary-page ach-results-page">
                <div className="secondary-page-header">
                    <div className="container flex-justify flex-center">
                        <div className="flex-one flex">
                            <button 
                                className="btn btn-flat btn-small back-btn" 
                                onClick={this.props.onClose}
                            >
                                <i className="icon ion-ios-arrow-back icon-left" />
                                Back to Applications
                            </button>
                        </div>
                        <div className="flex-one" style={{textAlign: 'center'}}>
                            <h4 className="page-header">
                                ACH Results 
                                <span className="printing-tag">{achResults.length}</span>
                            </h4>
                        </div>
                        <div className="flex-one flex-right">
                        </div>
                    </div>
                </div>
                <div className="container secondary-page-content">
                    <ACHResultsTable
                        achTransfers={achResults}
                    />
                </div>
                {achResults.length > 0 && (
                    <div className="secretary-page-footer">
                        <div className="flex-justify container">
                            <p className="small-text">
                                Total {achResults.length} Transfer{achResults.length > 1 ? "s" : ""} 
                                ({successfulTransfers.length} successful, {transfersFailed.length} failed)
                            </p>
                            <button 
                                className="btn btn-accent2" 
                                onClick={this.props.onClose}
                            >
                                OK - Back to Applications
                            </button>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {}
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({ getApplications }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ACHResultsPage);


// WEBPACK FOOTER //
// ./src/components/achComponents/ACHResultsPage.jsx